import * as React from 'react';
import { colors } from '../styles/colors';
import { largeShadow } from '../styles/styleObjects';
import { waitForSeconds } from '../util/waitForSeconds';
import { CommonTextInput } from './CommonTextInput';

interface IProps<T> {
    value: string;
    onChangeText(value: string): void;
    containerStyle?: React.CSSProperties;
    header: string;
    placeholder: string;
    suggestions: Array<{ display: string; value: T }>;
    onPressSuggestion(suggestion: T): void;
}

export class SuggestionTextInput<T extends string | {toString(): string; }> extends React.Component<IProps<T>, { isFocused: boolean }> {
    public state = { isFocused: false };

    public render() {
        const { header, placeholder, value, suggestions, onChangeText, onPressSuggestion, containerStyle } = this.props;
        return (
            <div style={{ ...relativePosition, ...containerStyle }}>
                <CommonTextInput
                    value={value}
                    containerStyle={inputContainerStyle}
                    onChangeText={onChangeText}
                    header={header}
                    placeholder={placeholder}
                    onFocus={() => this.setState({ isFocused: true })}
                    onBlur={async () => {
                        await waitForSeconds(0.3);
                        this.setState({ isFocused: false });
                    }}
                />
                {suggestions.length > 0 &&
                    this.state.isFocused && (
                        <div style={suggestionsContainerStyle} className="customScrollBar">
                            {suggestions.map((suggestion, index) => (
                                <div
                                    key={(typeof suggestion.value === 'string' ? suggestion.value : suggestion.value.toString()) + index}
                                    onClick={() => onPressSuggestion(suggestion.value)}
                                    style={suggestionRowStyle}
                                >
                                    <p>{suggestion.display}</p>
                                </div>
                            ))}
                        </div>
                    )}
            </div>
        );
    }
}


const relativePosition = {
    position: 'relative'
} as React.CSSProperties;

const inputContainerStyle = {
    width: '100%',
    height: 75,
    marginBottom: 15,
    backgroundColor: 'white',
    boxShadow: largeShadow
};

const suggestionRowStyle: React.CSSProperties = {
    height: 50,
    paddingLeft: 18,
    alignItems: 'center',
    display: 'flex',
    cursor: 'pointer',
    borderTop: `1px solid ${colors.LIGHT_BORDER}`,
    borderBottom: `1px solid ${colors.LIGHT_BORDER}`
};

const suggestionsContainerStyle: React.CSSProperties = {
    boxShadow: largeShadow,
    backgroundColor: 'white',
    height: 125,
    position: 'absolute',
    left: 0,
    right: 0,
    top: 75,
    zIndex: 2,
    overflowY: 'scroll'
};



// WEBPACK FOOTER //
// ./src/SharedComponents/SuggestionTextInput.tsx